export enum ApiType
{
    AD_UNIT_MANAGEMENT_API = 'ad_unit_management_api',
    MAX_REPORTING_API = 'max_reporting_api',
    USER_REVENUE_API = 'user_revenue_api',
    MAX_COHORT_API = 'max_cohort_api',
    DIRECT_SOLD_API = 'direct_sold_api',
    S2S_REWARDED_CALLBACK_API = 's2s_rewarded_callback_api',
    S2S_IMPRESSION_REVENUE_API = 's2s_impression_revenue_api',
    MAX_REVENUE_API = 'max_revenue_api',
    CAMPAIGN_MANAGEMENT_API = 'campaign_management_api',
}

export type ApiManifest =
    {
        [type in ApiType]: {
            [tableName: string]: Array<Api>
        }
    };

type Api =
    {
        name: string,
        description: string,

        example?: string,
        extras?: ApiExtras,
        hasLink?: boolean
    };

type ApiExtras =
    {
        required?: string,
        requiredOnCreate?: string,
        requiredOnUpdate?: string,
        adNetworkAppId?: string,
        adNetworkAppKey?: string,
        adNetworkAdUnitId?: string,
        categoryId?: string,
        categoryName?: string,
    };

export default Api;
